import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

export interface SearchResult {
  id: string;
  name: string;
  type: 'Lead' | 'Client' | 'Opportunity' | 'Task';
  context: string;
  route: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/search`;

  constructor() { }

  search(query: string) {
    return this.http.get<any>(`${this.apiUrl}`, { params: { q: query } });
  }
}
